import React from 'react';
import Meetings from './../../Meetings';

const MeetingsTab = ({ SelectedBrief, Professionals, SelectedProfessional, AllUsers }) => {
    return (
        <div className='BriefInfoSection'>
            <Meetings 
                Brief={SelectedBrief} 
                Professionals={Professionals} 
                SelectedProf={SelectedProfessional} 
                AllUsers={AllUsers} 
            />
        </div>
    );
};

export default MeetingsTab;